import { Card } from "@/components/ui/card";
import { unixToJST } from "@/utils/time";
import { Tag } from "../Tag";
import { Title } from "./Title";

interface Props {
  choiceComponent: React.ReactNode;
  tag?: string;
  title: string;
  totalPoints?: number;
  entryOpenTime: number;
  entryCloseTime: number;
}

export const MarketCardListItem = ({
  choiceComponent,
  tag,
  title,
  totalPoints,
  entryOpenTime,
  entryCloseTime,
}: Props) => {
  return (
    <Card className="hover:shadow-lg transition-shadow duration-200">
      <div className="p-5">
        <div className="flex items-center gap-2 text-xs text-gray-600 mb-1 text-light-gray">
          <span>開始: {unixToJST({ unix_milliseconds: entryOpenTime })}</span>
          <span>終了: {unixToJST({ unix_milliseconds: entryCloseTime })}</span>
        </div>
        {tag && (
          <div className="mb-2">
            <Tag text={tag} />
          </div>
        )}
        <Title text={title} />
        <div>{choiceComponent}</div>
        {totalPoints && <div className="text-md font-bold mt-4 text-primary">{totalPoints} pt</div>}
      </div>
    </Card>
  );
};
